import React, { useState } from "react";
import { Card, Row, Col, Dropdown } from "react-bootstrap";
import Chart from "react-apexcharts";
import { FiCalendar, FiTrendingUp } from "react-icons/fi";
import { MdCalendarMonth, MdKeyboardArrowDown } from "react-icons/md";

export default function AttendanceDashboard() {

  // ✅ only for data (UI won't change text)
  const [year, setYear] = useState("2024");

  // ✅ dynamic data
  const chartData = {
    "2024": {
      present: [30, 65, 70, 75, 80, 90, 95, 70, 65],
      absent: [28, 55, 60, 65, 68, 72, 78, 60, 68]
    },
    "2023": {
      present: [20, 40, 55, 60, 70, 80, 85, 60, 50],
      absent: [25, 35, 45, 50, 55, 65, 70, 55, 60]
    },
    "2022": {
      present: [15, 35, 50, 55, 60, 70, 75, 50, 45],
      absent: [20, 30, 40, 45, 50, 60, 65, 55, 58]
    }
  };

  const chartOptions = {
    chart: { toolbar: { show: false } },
    stroke: { curve: "smooth", width: 3 },
    colors: ["#16a34a", "#ec4899"],
    xaxis: {
      categories: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep"]
    },
    legend: { position: "bottom" },
    grid: { borderColor: "#eee" }
  };

  const series = [
    { name: "Present", data: chartData[year].present },
    { name: "Absent", data: chartData[year].absent }
  ];

  return (
    <Row className="g-3 m-0 ">

      {/* LEFT SIDE */}
      <Col xl={6} lg={6} md={12}>
        <Row className="g-3">

          {[
            { title: "Total Working Days", value: 25, color: "#f26522" },
            { title: "Total Leave Taken", value: 12, color: "#3b82f6" },
            { title: "Total Holidays", value: 6, color: "#ec4899" },
            { title: "Total Halfdays", value: 5, color: "#f59e0b" }
          ].map((item, i) => (

            <Col md={6} key={i}>
              <Card className="attendance-card h-100">
                <Card.Body>

                  <div className="d-flex align-items-center mb-2">

                    {/* ICON */}
                          <div
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#f8fafc",
                      }}
                    >
                      <MdCalendarMonth size={28} color={item.color} />
                    </div>

                    <div className="ms-2">
                      <p className="small mb-1">{item.title}</p>
                      <h4 className="mb-0">{item.value}</h4>
                    </div>

                  </div>

                  {/* PROGRESS */}
                  <div className="progress small-progress">
                    <div
                      className="progress-bar bg-success"
                      style={{ width: "85%" }}
                    ></div>
                  </div>

                  {/* TEXT */}
                  <p className="small mt-2 text-muted">
                    <span className="text-success me-1">
                      <FiTrendingUp /> +20.01%
                    </span>
                    from last month
                  </p>

                </Card.Body>
              </Card>
            </Col>

          ))}

        </Row>
      </Col>

      {/* RIGHT SIDE */}
      <Col xl={6} lg={6} md={12}>
        <Card className="h-100">

          <Card.Header style={{backgroundColor:"#fff"}} className="border-0 pb-0 d-flex justify-content-between align-items-center">

            <div className="d-flex align-items-center">
              <FiTrendingUp className="text-danger me-2" />
              <h5 className="mb-0">Attendance</h5>
            </div>

            {/* DROPDOWN */}
            <Dropdown>
              <Dropdown.Toggle className="btn-white small">
                This Year
                <MdKeyboardArrowDown />
              </Dropdown.Toggle>

              <Dropdown.Menu align="end" className="dropdown-ui">
                <Dropdown.Item onClick={() => setYear("2024")}>2024</Dropdown.Item>
                <Dropdown.Item onClick={() => setYear("2023")}>2023</Dropdown.Item>
                <Dropdown.Item onClick={() => setYear("2022")}>2022</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

          </Card.Header>

          <Card.Body>
            <Chart
              options={chartOptions}
              series={series}
              type="line"
              height={200}   
            />
          </Card.Body>

        </Card>
      </Col>

      {/* CSS */}
      <style>
        {`
        .attendance-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
        }

        /* 🔥 ICON SIZE INCREASED */
        .icon-box {
          width: 48px;
          height: 48px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f8fafc;
          font-size: 22px;
        }

        .small-progress {
          height: 5px;
          border-radius: 10px;
        }

        .btn-white {
          background: #fff !important;
          border: 1px solid #e5e7eb !important;
        }

        .dropdown-ui .dropdown-item:hover {
          background: #f26522 !important;
          color: #fff !important;
        }

        @media (max-width: 768px) {
          .attendance-card {
            text-align: center;
          }
        }
        `}
      </style>

    </Row>
  );
}